import { render, staticRenderFns } from "./RSEcard.vue?vue&type=template&id=73b236f8&scoped=true"
import script from "./RSEcard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RSEcard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RSEcard.vue?vue&type=style&index=0&id=73b236f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b236f8",
  null
  
)

export default component.exports